<div class="container-fluid" [class.px-0]="noPadding">
  <div class="row">
    <div class="col-12 text-center">
      <div *ngIf="showTotalMessage" class="pull-left d-inline-block totalMsg">
        <p class="bold">Found {{totalRecords}} {{entityType}}</p>
      </div>
      <div class="pull-left pagination-spacing">
        <ngb-pagination
                [collectionSize]="totalRecords"
                [pageSize]="pagination.pagesize"
                [directionLinks]="pagination.directionLinks"
                [maxSize]="pagination.maxPaginationItems"
                [boundaryLinks]="pagination.boundaryLinks"
                [ellipses]="pagination.ellipses"
                [rotate]="pagination.rotate"
                [size]="pagination.size"
                [(page)]="pagination.page"
                (pageChange)="emitPageChange()">
          <ng-template ngbPaginationEllipsis>
            <span class="ellipsis-divider">|</span>
          </ng-template>
          <ng-template ngbPaginationPrevious>
            <i class="fa fa-angle-left"></i>
          </ng-template>
          <ng-template ngbPaginationNext>
            <i class="fa fa-angle-right"></i>
          </ng-template>
        </ngb-pagination>
      </div>
      <div class="pull-right d-flex mt-2">
        <span class="align-self-center text-uppercase view-label">{{"HEADER.VIEW" | translate}}:</span>
        <div class="pull-right w-auto">
          <ng-select
                  [dropdownPosition]="configDropdownCounter.dropdownPosition"
                  [clearable]="false"
                  [searchable]="false"
                  [items]="pagination.allowedRanges"
                  [disabled]="!(totalRecords > 0)"
                  bindLabel="range"
                  bindValue="range"
                  [placeholder]="'-'"
                  (change)="emitRecordsPerPageChange()"
                  class="width-page-results"
                  [(ngModel)]="pagination.pagesize">
          </ng-select>
        </div>
      </div>
    </div>
  </div>
</div>
